import React from 'react';

import ContentPage from '@/src/cms/components/CMSPage/Content';
import withAuthentication from '@/src/shared/components/WithAuthentication';

const International = props => {
  return <ContentPage {...props} />;
};

export async function getStaticProps() {
  return {
    props: {
      sitepageid: 600,
    },
  };
}

export default withAuthentication(International);
